import type { IProjectExtraYieldSettingsLegacy } from '~/@api/generated-api-types-project/Api'
import Finance from '~/@lib/utils/finance.utils'

type CalculateRevenueFeeNettoAmountProps = {
  revenueAmount: number
  fee: number
}

export function calculateRevenueFeeNettoAmount(
  props: CalculateRevenueFeeNettoAmountProps
) {
  return Finance.round(props.revenueAmount - _calculateRevenueFee(props))
}

export function calculateRevenueFeeNettoAmountUnrounded(
  props: CalculateRevenueFeeNettoAmountProps
) {
  return props.revenueAmount - _calculateRevenueFee(props)
}

export function calcExtraYieldPerAnnum(
  { maxPercentage, maxAmount }: IProjectExtraYieldSettingsLegacy,
  investmentPrincipal: number
): number {
  if (!maxPercentage || !maxAmount) return 0

  // The max extra yield is capped by maxAmount
  const cappedAmount = Math.min(maxAmount, investmentPrincipal)

  const stepAmount = maxAmount / (maxPercentage * 100)

  // How many steps is the investment worth
  const stepCount = Math.floor(cappedAmount / stepAmount)

  const yieldPerStep = 0.01 // Each "step" gives you 0.01%
  const extraYieldPerAnnum = Finance.round(yieldPerStep * stepCount)

  return extraYieldPerAnnum
}

function _calculateRevenueFee(props: CalculateRevenueFeeNettoAmountProps) {
  return props.revenueAmount * props.fee
}
